(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flick-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.fk-rev').forEach(function(sec){
    var track=sec.querySelector('[data-fk-rev-track]');
    var prog=sec.querySelector('[data-fk-rev-prog]');
    var arrows=sec.querySelectorAll('[data-fk-rev]');
    if(!track) return;
    function step(){ var c=track.querySelector('.fk-rev-card'); return c? c.offsetWidth+24 : 400; }
    arrows.forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({left: step()*parseInt(b.getAttribute('data-fk-rev'),10), behavior:'smooth'}); }); });
    function update(){
      var max=track.scrollWidth-track.clientWidth;
      var pct=max>0? track.scrollLeft/max : 0;
      var prev=sec.querySelector('[data-fk-rev="-1"]'), next=sec.querySelector('[data-fk-rev="1"]');
      if(prev) prev.disabled = track.scrollLeft<=2;
      if(next) next.disabled = track.scrollLeft>=max-2;
      if(prog){ var w=Math.max(15, track.clientWidth/track.scrollWidth*100); prog.style.width=w+'%'; prog.style.marginLeft=(pct*(100-w))+'%'; }
    }
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
